import React from "react";
import { useEffect, useState } from "react";
import anker from "../../images/arrow.png"
import "./anker.css";

const Anker = () => {
  const [backToTopButton, setBackToTopButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setBackToTopButton(true);
      } else {
        setBackToTopButton(false);
      }
    });
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      {backToTopButton && (
        <button className="back-to-top-button" onClick={scrollUp}>
          <img src={anker} alt="xfuivefb"></img>
        </button>
      )}
    </div>
  );
};

export default Anker;
